import React, { useImperativeHandle, useState, forwardRef, Children } from "react";
import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import { useValueChange } from "../../shared/customHooks";

interface ModalProps {
  confirmAction: () => void;
  cancelAction?: () => void;
  bodyText?: string;
  children?: React.ReactNode;
  headerLabel?: string;
  confirmLabel?: string;
  rejectLabel?: string;
}
export type ModalRef = {
  toggle: () => void;
};

export const Modal = forwardRef<ModalRef, ModalProps>(
  ({ confirmAction, cancelAction, children, bodyText, headerLabel = "Warning", confirmLabel = "I Agree", rejectLabel = "Cancel" }, ref) => {
    const [visible, setVisible] = useState(false);

    const toggle = () => {
      setVisible(!visible);
    };

    useImperativeHandle(ref, () => ({
      toggle,
    }));

    useValueChange(visible, () => {
      if (!visible) cancelAction?.();
    });

    return (
      <>
        {visible && (
          <Dialog
            className="dont-show-in-print modal-styles"
            visible={visible}
            onHide={() => setVisible(false)}
            header={
              <div className="flex items-center justify-between border-round-top">
                <div className="flex items-center text-purple">
                  <i aria-hidden="true" className="pi pi-exclamation-triangle mr-2" />
                  <span>{headerLabel}</span>
                </div>
              </div>
            }
            footer={
              <div className="flex justify-center gap-2 pb-3">
                <Button label={confirmLabel} onClick={confirmAction} autoFocus className="filled-round-button" />
                <Button
                  label={rejectLabel}
                  onClick={() => {
                    setVisible(false);
                  }}
                  className="outline-button"
                />
              </div>
            }>
            <div className="p-4 border-b mb-5">
              <p className="text-left">{bodyText}</p>
              {Children.map(children, (child) => child)}
            </div>
          </Dialog>
        )}
      </>
    );
  }
);
Modal.displayName = "Modal";
